import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { tailwindPalette } from "../../../../../modules/theme/tailwindPalette"
import { ExpandableText } from "../../../text/ExpandableText"

const useStyles = makeStyles()(() => ({
    box: {
        padding: "1.25rem",
        borderRadius: "1rem",
        color: tailwindPalette.sky[700],
        background: tailwindPalette.blue[50],
    },
}))

type DeliveryNoteProps = Readonly<{
    text: string
}>

export function DeliveryNote({ text }: DeliveryNoteProps) {
    const { classes } = useStyles()

    if (!text) return null

    return (
        <Box className={classes.box}>
            <ExpandableText text={text} variant="body1" />
        </Box>
    )
}
